import styled from 'styled-components';
import { colors } from '../../../../styles/colors';

interface IDCBudgetDropdown {
    opened: boolean;
    lengthQuoteItem: number;
    index: number;
}

export const ColoredSelect = styled.div<IDCBudgetDropdown>`
    .select {
        position: relative;
        height: 26px;
        width: 60px;

        background: #FFFFFF;
    }
    .text {
        padding-left: 8px;
        padding-top: 6px;

        font-size: 12px;
        font-weight: 400;
        color: ${colors.blueDark};
        cursor: default;
    }
    .emptystock {
        color: ${colors.mfRed};
    }
    .emptystock:hover {
        color: ${colors.white};
        background-color: ${colors.mfRed} !important;
    }
    .options-container {
        position: absolute;
        min-height: 26px;
        max-height: 150px;
        overflow-y: auto;

        width: 100%;
        ${
            props => props.lengthQuoteItem <= 1 || props.lengthQuoteItem === props.index + 1 ? `
                bottom: 100%;
            ` : `top: 100%;`
        }

        display: flex;
        flex-direction: column;

        border: 1px solid #BEBEBE;

        ${
            props => props.lengthQuoteItem <= 1 || props.lengthQuoteItem === props.index + 1 ? 
            `
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
            ` :
            `
                border-bottom-left-radius: 5px;
                border-bottom-right-radius: 5px;                
            `
        }
        
        background: #FFFFFF;
        z-index: 99999;
    }
    .box-wrapper {
        position: relative;

        min-height: 26px;
        width: 100%;
    }
    .options {
        display: flex;
        justify-content: space-between;
    }
    .options:hover {
        color: ${colors.white};
        background-color: ${colors.greenDarkViveo};
    }
    .options:hover svg {
        fill: ${colors.white};
    }
    .selected {
        display: flex;
        padding-top: 0;

        align-items: center;
        justify-content: space-between;
        height: 100%;

        border: 1px solid #BEBEBE;
        box-sizing: border-box;
        ${
            props => props.lengthQuoteItem <= 1 || props.lengthQuoteItem === props.index + 1 ? 
            `
                border-top-left-radius: ${ props.opened ? '0' : '5px' };
                border-top-right-radius: ${ props.opened ? '0' : '5px' };
                border-bottom-left-radius: 5px;
                border-bottom-right-radius: 5px;
            ` :
            `
                border-bottom-left-radius: ${ props.opened ? '0' : '5px' };
                border-bottom-right-radius: ${ props.opened ? '0' : '5px' };
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
            `
        }
    }
    .emptystockselected {
        color: ${colors.white};
        background-color: ${colors.mfRed} !important;
    }
    .emptystockselected svg, .idealbillingdcselected svg {
        fill: ${colors.white} !important;
    }
    .idealbillingdcselected {
        color: ${colors.white};
        background-color: ${colors.greenDarkViveo};
    }
    .DCDropdwn-img {
        fill: ${colors.greenDarkViveo};
        margin-right: 6px;
        ${
          props => props.opened && (`transform: rotate(180deg);`)
        }
      }
      .DCIdealBilling-img {
        margin-right: 6px;
        fill: ${colors.greenDarkViveo};
      }
`